import { Coordinates } from '../types/catalog'

const EARTH_RADIUS_MILES = 3958.8

/** Default estimate for a contract truck, in dollars per loaded mile. */
export const DEFAULT_HAUL_RATE = 6.5

function toRadians(value: number): number {
  return (value * Math.PI) / 180
}

/** Great-circle distance, padded to approximate real road mileage. */
export function roadDistanceMiles(a: Coordinates, b: Coordinates): number {
  const dLat = toRadians(b.lat - a.lat)
  const dLng = toRadians(b.lng - a.lng)
  const h =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRadians(a.lat)) * Math.cos(toRadians(b.lat)) * Math.sin(dLng / 2) ** 2
  const straightLine = 2 * EARTH_RADIUS_MILES * Math.asin(Math.sqrt(h))
  return straightLine * 1.18
}

export function formatMiles(miles: number): string {
  return miles < 10 ? miles.toFixed(1) : Math.round(miles).toString()
}

export function formatCurrency(value: number, fractionDigits = 2): string {
  return value.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  })
}
